import { useContext } from 'react'

// DON'T replace this with "./MediaContext" - there will be error in SSR bcs context should be imported from same module file
import MediaContext from 'sb-hooks/MediaContext'


const useMedia = () => useContext<MediaProps & Device>(MediaContext)


export default useMedia
